import { TripContext } from 'contexts'
import { useContext } from 'react'
import { LineItemBarcode } from 'services/types'

export const useLineItemService = () => {

    const tripContext = useContext(TripContext)

    const deleteLineItems = (lineItemIds: number[]): void => {
        const staleBarcodes: LineItemBarcode[] = tripContext.lineItemBarcodes.filter(barcode => lineItemIds.includes(barcode.lineItemId))
        tripContext.lineItems.bulkRemove(lineItemIds),
        tripContext.lineItemBarcodes.bulkRemove(staleBarcodes.map(barcode => barcode.id))
    }

    return {
        deleteLineItems: deleteLineItems
    }

}